export const survey = {
    "_id" : "AVIS_CUSTOMER_CARE_CX",
    "title" : "AVIS CUSTOMER CARE",
    "dashboarddescription" : "AVIS CUSTOMER CARE",
    "description" : "AVIS CUSTOMER CARE",
    "company" : "AVIS",
    "companydata_id": "bPeNeCGJ2qtAVSCUS",
    "fields" : [
        {
            "name" : "H1",
            "type" : "string",
            "optional" : true,
            "props" : {
                "html" : "Customer Care Email Survey",
                "tag" : "h1"
            }
        },
        {
            "name" : "H2",
            "type" : "string",
            "optional" : true,
            "props" : {
                "html" : "<br /> Thank you for your query sent to the AVIS Customer Care team.<br/> In support of measuring agents' effectiveness, we are evaluating customers' satisfaction with their response. Please complete the following survey. <br /> <br />",
                "tag" : "p"
            }
        },
        {
            "name" : "H3",
            "type" : "string",
            "optional" : true,
            "props" : {
                "html" : "With regards to the AVIS Customer Care Department... ",
                "tag" : "h2"
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "CCValid",
            "optional" : false,
            "type" : "string",
            "props" : {
                "label" : "Have you received any response from the Customer Care Department on your email of a week ago?",
                "checkboxes" : true,
                "allowedValues" : [
                    {
                        "label" : "Yes",
                        "value" : "Yes"
                    },
                    {
                        "label" : "No",
                        "value" : "No"
                    }
                ],
                "errorMessage" : "Please click to select an option."
            }
        },
        {
            "name" : "C5",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "The email being answered in a professional manner?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V5",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "Please tel us more about your experience?",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C5: {$lt: 7}} ]}",
        },
        {
            "name" : "C6",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "The agent's helpfulness and courtecy?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V6",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "Please give a reason for this score. Do you have any suggestion for improvement? ",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C6: {$lt: 7}} ]}"
        },
        {
            "name" : "C8",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "The agent's product knowledge and understanding of your needs?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V8",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "Please give a reason for this score. Do you have any suggestion for improvement? ",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C8: {$lt: 7}} ]}"
        },
        {
            "name" : "C7",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "Your query being resolved to your satisfaction?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V7",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "Please describe how we can better meet your expectation?",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C7: {$lt: 7}} ]}"
        },
        {
            "name" : "C9",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "Receiving your response within the promised time frame?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V9",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "How long did you wait for a response, and what response time were you expecting?",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C9: {$lt: 7}} ]}"
        },
        {
            "name" : "C10",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "The agent managing your enquiry professionally and with a sense of urgency?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V10",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "Please tel us more about your experience?",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C10: {$lt: 7}} ]}"
        },
        {
            "name" : "C11",
            "type" : "number",
            "optional" : true,
            "props" : {
                "label" : "The agent seemed genuinely keen to assist you?",
                "min" : 0.0,
                "max" : 10.0,
                "errorMessage" : "Please enter correct value",
                "initialValue" : -1
            },
            "visibleIf" : "{CCValid: {$eq: 'Yes'}}"
        },
        {
            "name" : "V11",
            "type" : "string",
            "optional" : true,
            "props" : {
                "label" : "Please tel us more about your experience?",
                "rows" : 3.0
            },
            "visibleIf" : "{$and: [{CCValid: {$eq: 'Yes'}}, {C11: {$lt: 7}} ]}"
        },
        {
            "name" : "email_id",
            "lst_name" : "email_id",
            "optional" : true,
            "type" : "string",
            "props" : {
                "label" : "email_id",
                "invisible" : true
            }
        },
        {
            "name" : "email",
            "lst_name" : "email",
            "optional" : true,
            "type" : "string",
            "props" : {
                "label" : "email",
                "invisible" : true
            }
        },
        {
            "name" : "email_timestamp",
            "lst_name" : "email_timestamp",
            "optional" : true,
            "type" : "string",
            "props" : {
                "label" : "email_timestamp",
                "invisible" : true
            }
        }
    ],
    "pages" : [
        {
            "fields" : [
                "H1",
                "H2",
                "CCValid",
                "H3",
                "C5",
                "V5",
                "C6",
                "V6",
                "C8",
                "V8",
                "C7",
                "V7",
                "C9",
                "V9",
                "C10",
                "V10",
                "C11",
                "V11"
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/data/AVIS_CUSTOMER_CARE_CX.js